import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './ui.js';
import { SessionGate } from './SessionGate.js';
import { TypologyPage } from './typology-page.js';
import { useSession } from './session.js';
import {
  AccountStatusPage,
  BootPage,
  ChatPage,
  ChatsPage,
  DiscoverPage,
  LegalPage,
  LikesPage,
  MatchPage,
  NotFoundPage,
  OnboardingPage,
  PhotoUploadPage,
  ProfilePhotosPage,
  ProfileEditPage,
  PublicProfilePage,
  SearchSettingsPage,
  ProfilePage,
  SettingsPage,
  SignedOutPage,
  SupportPage,
  WelcomePage,
} from './pages.js';

export function App() {
  const deletionInProgress = useSession((state) => state.deletionPhase !== 'NONE');
  if (deletionInProgress)
    return (
      <AppShell>
        <SessionGate />
      </AppShell>
    );
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Navigate to="/boot" replace />} />
        <Route path="/boot" element={<BootPage />} />
        <Route path="/signed-out" element={<SignedOutPage />} />
        <Route path="/legal/:document" element={<LegalPage />} />
        <Route element={<SessionGate />}>
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/onboarding/:step" element={<OnboardingPage />} />
          <Route path="/account/status" element={<AccountStatusPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/likes" element={<LikesPage />} />
          <Route path="/match" element={<MatchPage />} />
          <Route path="/matches" element={<ChatsPage />} />
          <Route path="/chats" element={<ChatsPage />} />
          <Route path="/chat/:conversationId" element={<ChatPage />} />
          <Route path="/typology" element={<TypologyPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:profileId" element={<PublicProfilePage />} />
          <Route path="/profile/edit" element={<ProfileEditPage />} />
          <Route path="/profile/photos" element={<ProfilePhotosPage />} />
          <Route path="/profile/photos/add" element={<PhotoUploadPage />} />
          <Route path="/search-settings" element={<SearchSettingsPage />} />
          <Route path="/settings/*" element={<SettingsPage />} />
          <Route path="/support" element={<SupportPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
